/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.66669 5.59749L8.87549 0.388123L9.67732 1.18939L3.66669 7.20002L0.0604248 3.59376L0.861691 2.79249L3.66669 5.59749Z"
      fill={props.fill || '#00BD84'}
    />
  </svg>
);

export default CheckIcon;
